// This file is auto-generated. Edit data.graphql to change it.
import { DataProvider , useSetFlowToBasedOnData } from 'Simple/Data'
import { useQuery } from 'Data/Api'
import query from './data.graphql.js'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function DefinitionsData(props) {
  let [{ data: rdata, fetching, error }, reExecuteQuery] = useQuery({ query })
  let data = rdata?.definitions

      useSetFlowToBasedOnData({
        data,
        fetching,
        error,
        pause: false,
        viewPath: props.viewPath,
      })
      

  return (
    <DataProvider
      context="definitions"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}